import { createStore } from "vuex";

export const appStore = createStore({
  state: () => {
    return {
      c_file: null,
      collaborator: {
        name: null,
        cpf: null,
      },
      collaborators: [],

      training: null,
      aproveit: 100,
      descricao: null,
      dateLocale: "(cidade), 29 de (mês) de 2025",

      companies: {
        miniature: false,
        m_company: null,
      },
    };
  },
  getters: {
    getTrainingSelected: (state) => state.training,
  },
  mutations: {
    ALTER_VAL_DESCRIPT(state, payload) {
      state.descricao = payload;
    },
  },
  actions: {
    alterDescriptionByTraining({ commit }, value) {
      commit("ALTER_VAL_DESCRIPT", value);
    },
  },
});
